import $http from "@/plugins/axios.js";

export default {
  state: {
    cards: null,
    card: null,
    userCards: null,
    smartCards: null,
  },
  getters: {
    cards: (state) => state.cards,
    card: (state) => state.card,
    userCards: (state) => state.userCards,
    smartCards: (state) => state.smartCards,
  },
  mutations: {
    SET_CARDS(state, data) {
      data.card.forEach((item) => {
        item.selected = false;
      });
      state.cards = data;
    },
    SET_CARD(state, data) {
      state.card = data;
    },
    SET_USER_CARDS(state, data) {
      data.data.forEach((item) => {
        item.selected = false;
      });
      state.userCards = data;
    },
    SET_SMART_CARDS(state, data) {
      data.data.forEach((item) => {
        item.selected = false;
      });
      state.smartCards = data;
    },
  },
  actions: {
    async getCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `/card?take=${payload.take}&page=${payload.page}${
            payload.filters.startDate
              ? `&startDate=${payload.filters.startDate}`
              : ""
          }${
            payload.filters.endDate ? `&endDate=${payload.filters.endDate}` : ""
          }${payload.filters.used ? `&used=${payload.filters.used}` : ""}${
            payload.filters.type ? `&type=${payload.filters.type}` : ""
          }${payload.filters.id ? `&id=${payload.filters.id}` : ""}${
            payload.filters.email ? `&email=${payload.filters.email}` : ""
          }
          `
        );
        dispatch("toggleIsLoading", false);
        commit("SET_CARDS", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_CARDS", null);
        // throw err;
      }
    },

    async getUserCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        // /userwallet get all generated cards
        // /userwallet/usercard get all wallet cards
        // ${payload.filters.printed ? `&printed=${payload.filters.printed}` : ""}
        let res = await $http.get(
          `/userwallet?take=${payload.take}&page=${payload.page}${
            payload.filters.printed ? `&printed=${payload.filters.printed}` : ""
          }`
        );
        dispatch("toggleIsLoading", false);
        commit("SET_USER_CARDS", res.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_USER_CARDS", null);
        // throw err;
      }
    },

    async getSmartCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `/account?take=${payload.take}&page=${payload.page}${
            payload.filters.printed ? `&printed=${payload.filters.printed}` : ""
          }`
        );
        dispatch("toggleIsLoading", false);
        commit("SET_SMART_CARDS", res.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_SMART_CARDS", null);
        // throw err;
      }
    },

    async addUserCards({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/userwallet", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },

    async addSmartCards({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/account", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },

    async printCards({ commit }, id) {
      try {
        await $http.patch(`/store/print/${id}`);
        return { commit };
      } catch (err) {
        console.log(err);
      }
    },

    async printUserCards({ commit }, id) {
      try {
        await $http.patch(`/userwallet/print/${id}`);
        return { commit };
      } catch (err) {
        console.log(err);
      }
    },

    async printSmartCards({ commit }, id) {
      try {
        await $http.patch(`/account/print/${id}`);
        return { commit };
      } catch (err) {
        console.log(err);
      }
    },

    async uploadExcel({ commit, dispatch }, file) {
      console.log("upload excel");
      dispatch("toggleBtnLoading", true);
      try {
        let data = new FormData();
        data.append("tier", file.tier);
        data.append("type", file.type);
        data.append("file", file.excelFile);
        data.append("storeName", file.storeName);
        await $http.post("/card/upload", data);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        return { commit };
      } catch (err) {
        if (
          err.response.status === 500 ||
          err.response.status === 403 ||
          err.response.status === 400 ||
          err.response.status === 413
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
      } finally {
        dispatch("toggleBtnLoading", false);
      }
    },

    async addCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/card", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
    async editCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.patch(`/card/${payload.id}`, payload);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        dispatch("toggleBtnLoading", false);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        throw err;
      }
    },
    async deleteCard({ dispatch, commit }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.delete(`/card/${id}`);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم حذف البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        return;
      }
    },
  },
};
